import request from '@/service/api'
import ConfigType from '@/service/api/type'
// 任务管理
enum MissionApi {
    // 任务列表
    pageMaterial = '/BlackWarehouse/pageMaterial', //分页查询物料
    addMaterial = '/BlackWarehouse/addMaterial',//新增物料表
    deleteMaterial = '/BlackWarehouse/deleteMaterial',//删除物料表
    editMaterial = '/BlackWarehouse/editMaterial',//更新物料表
    BlackMaterialPrintInput = '/BlackWarehouse/BlackMaterialPrintInput',//物料标签打印查询
    BlackStockPage = '/BlackWarehouse/BlackStockPage',//分页查询库存列表
}
//************************ 任务列表 ************************/
// 分页查询物料
export const pageMaterial = (data: any): ConfigType<any> => {
    return request({
        url: `${MissionApi.pageMaterial}`,
        params: data
    })
}
//删除物料表
export const deleteMaterial = (data: any): ConfigType<any> => {
    return request({
        url: MissionApi.deleteMaterial,
        method: 'post',
        data: data
    })
}
// 新增物料表
export const addMaterial = (data: any): ConfigType<any> => {
    return request({
        url: MissionApi.addMaterial,
        method: 'post',
        data: data
    })
}
// 删除物料表
export const editMaterial = (data: any): ConfigType<any> => {
    return request({
        url: MissionApi.editMaterial,
        method: 'post',
        data: data
    })
}
// 分页查询库存列表
export const BlackStockPage = (data: any): ConfigType<any> => {
    return request({
        url: `${MissionApi.BlackStockPage}`,
        params: data
    })
}
// 物料标签打印查询
export const BlackMaterialPrintInput = (data: any): ConfigType<any> => {
    return request({
        url: `${MissionApi.BlackMaterialPrintInput}`,
        params: data
    })
}